<template>
  <div class="assets-approvel">
    <div class="assets-approvel-container">
      <div class="left-container">
        <div class="add-type-content">
          <div v-if="procedureList.length > 0">
            <div
              :class="activeIndex === index?'type active':'type'"
              v-for="(item,index) in procedureList"
              :key="index"
              @click="selectType(index, item)"
            >
              <div class="type-title">
                <img src="../assets/tree/random.png">
                <div>{{item.name}}</div>
              </div>
              <el-dropdown
                v-if="
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleAddDelApproveSetting
                  ) !== -1
                "
                trigger="click"
                @command="handleCommand"
              >
                <span class="el-dropdown-link">
                  <img src="../assets/tree/three-spot.png">
                </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item :command="beforeHandleCommand(item, 'delete', index)" class="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="nothing-add" v-if="procedureList.length == 0">
            <div>
              <div>
                <img src="../assets/nothing-add.png">
              </div>
              <p>请先增分类</p>
            </div>
          </div>
        </div>
        <el-button
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleAddDelApproveSetting
            ) !== -1
          "
          type="text"
          class="btn-border-text-blue add-type"
          @click="addProcedure"
          >新增流程</el-button
        >
      </div>
      <div class="right-container">
        <div v-if="procedureList.length > 0">
          <div class="sub-title">发起审批</div>
          <div class="row">
            <div class="step">
              <div class="step-num">0</div>
              <div class="step-main step-main-agent">
                <div class="step-main-left step-main-agent-left">
                  <span class="step-main-agent-left-title">经办人：</span>
                  <span class="step-main-agent-left-content">{{ agent }}</span>
                </div>
                <div class="step-main-right step-main-agent-right" @click="setUp">设置</div>
              </div>
            </div>
          </div>
          <div v-for="(item, index) in detailsList" :key="index">
            <div class="sub-title">{{item.approvelTitle}}</div>
            <div class="row">
              <div class="step">
                <div :class="item.isContinue?'step-active':'step-num'">{{index+1}}</div>
                <div class="step-main">
                  <div class="step-main-left">
                    {{ item.roleName }}
                    <span v-if="item.roleType == 3">：{{ item.userName }}</span>
                    <span v-if="item.roleType == 12">{{ item.userName }}</span>
                  </div>
                  <div class="step-main-right-container">
                    <div v-if="item.roleType == 12" class="step-main-right set" @click="setDepartmentPeople(index)">设置</div>
                    <div v-if="!item.isContinue" class="step-main-right" @click="skip(index)">跳过</div>
                    <div v-if="item.isContinue" class="step-main-right" @click="recovery(index)">
                      恢复
                    </div>
                  </div>
                </div>
              </div>
              <div class="financial-audit" v-if="item.roleType == 3">
                <span class="financial-title">审批人</span>
                <el-radio-group v-model="item.userId">
                  <el-radio
                    v-for="(financial, index) in financialAuditList"
                    :key="index"
                    :label="financial.userId"
                    :disabled="item.isContinue == 1?true:false"
                    >{{ financial.name }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div class="financial-audit" v-if="item.isNeedInput">
                <span class="financial-title">金额</span>
                <span>
                  <el-input
                    :disabled="item.isContinue == 1?true:false"
                    v-model="item.price"
                    class="gray white"
                    placeholder="请填写信息"
                    clearable
                  >
                  </el-input>
                </span>
              </div>
            </div>
            <div class="add-branch" v-if="isApprovelType == 5 || isApprovelType == 9">
              <p class="approvel-node-title">审批节点</p>
              <el-button
                type="text"
                :class="item.isDisabled?'btn-gray':'btn-border-text-blue'"
                :disabled="item.isDisabled"
                @click="addBranch(index)"
                >添加</el-button
              >
              <p>只能添加一次审批节点</p>
            </div>
            
            <div class="row" v-if="item.isBranch">
              <div class="step">
                <div class="step-node"></div>
                <div class="step-main">
                  <div class="step-main-left">节点审批人：{{item.nodeApproverName}}</div>
                  <div class="operation-btn">
                    <div class="step-main-right" @click="setNodeApprovelPeople(index)">设置</div>
                    <div class="step-main-right del" @click="delBranch(index)">
                      删除
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="(isApprovelType == 5 || isApprovelType == 8 || isApprovelType == 9)&&index == detailsList.length-1">
              <div class="sub-title">其他设置</div>
              <p class="condition">上会前置条件</p>
              <div class="condition-row">
                <span>金额</span>
                <el-input
                  class="gray white"
                  placeholder="请填写信息"
                  v-model="subLimit"
                  clearable
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="foot-container"
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleSavePropertyApproveSetting
            ) !== -1
          "
        >
          <el-button class="btn-blue" type="primary" @click="save"
            >保存</el-button
          >
        </div>
        <div class="nothing" v-if="procedureList.length == 0">
          <div>
            <div>
              <img src="../assets/nothing.png">
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择部门 -->
    <department-dialog
      :departmentDialog="departmentDialog"
      :isFlag="isFlag"
      :keyword="'property'"
      @oPenOrCloseDepartmentDialog="oPenOrCloseDepartmentDialog"
      @submitSelectData="submitSelectData"
    ></department-dialog>

    <!-- 选择资产管理部门负责人 -->
    <el-dialog
      title="选择资产管理部门负责人"
      :visible.sync="dialogRoleType3Visible"
      width="540px"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <div
          :class="
            departmentActiveIndex === index
              ? 'departmentActive department-people'
              : 'department-people'
          "
          v-for="(item, index) in departmentPeopleList"
          :key="index"
          @click="selectDepartmentPeople(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRoleType3Visible = false">取 消</el-button>
        <el-button type="primary" @click="dialogRoleType3Visible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 设置节点审批人 -->
    <el-dialog
      title="设置节点审批人"
      :visible.sync="dialogVisible"
      width="840px"
      :before-close="nodeApprovelPeopleClose"
    >
      <div class="stayDistribution">
        <div class="table-left">
          <div class="table-left-title">每次最多可添加3名审批人</div>
          <tree
            :isSearch="isSearch"
            :companyList="staffAndDepartmentList"
            :departmentId="assignDepartmentId"
            @selectTreeNodeList="selectAssignDepartment"
          />
        </div>
        <div class="table table-right">
          <div class="search-table">
            <el-input
              class="gray white"
              @keyup.enter.native="searchAssignPeople"
              v-model="staff"
              placeholder="请输入成员"
            ></el-input>
          </div>
          <el-table
            ref="multipleTable"
            :data="assignPeople"
            style="width: 100%"
            height="250"
            @selection-change="handleSelectionSKitchenChange"
          >
            <el-table-column type="selection" width="60"> </el-table-column>
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                <div class="assign-name">
                  <img :src="scope.row.image">
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer-node">
        <div class="node-select-approval">
          已选中：
          <div v-for="(item,index) in selectAssignPeople" :key="index" class="node-item-approval" :class="activeSelectNodeApproval == index?'active-node-item-approval':''" @click="highSelectNodeApproval(index)">
            {{item.name}}
            <i v-show="activeSelectNodeApproval == index" class="el-icon-circle-close" @click="removeSelectNodeApproval(index)"></i>
          </div>
        </div>
        <div>
          <el-button @click="nodeApprovelPeopleClose"
            >取 消</el-button
          >
          <el-button type="primary" @click="nodeApprovelPeopleConfirm">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DepartmentDialog from "@/components/department-dialog.vue";
import Tree from "@/components/Tree.vue";
import Assets from "@/models/assets.js"
import Approval from "@/models/approval.js";
import Staff from "@/models/staff.js";
import { getTeamId } from "common/js/storage";
import { mapId2, handleAmount } from "@/common/js/utils.js";
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],
  props: {
    departmentId: {
      type: Number,
    },
    /* 3:申领; 4：移交; 5：报废; 7:盘盈; 8:盘亏; 9:调拨; */
    isApprovelType: {
      type: Number,
    },
  },

  components: {
    DepartmentDialog,
    Tree
  },

  data() {
    return {
      activeIndex: 0,
      /* 流程集合 */
      procedureList: [],
      departmentDialog: false,
      isFlag: 2,
      agent: "",
      agentId: [],
      thirdDeptList: [],
      detailsList: [],
      approvelObj: {
        0: '部门审批',
        1: '财务审批',
        2: '管理审批',
      },
      financialAuditList: [],

      assignDepartmentId: 0,
      dialogVisible: false,
      isSearch: false,
      staff: "",
      assignPeople: [],
      staffAndDepartmentList: [],
      selectAssignPeople: [],
      stayDistributionTotalNum: 0,
      stayDistributionCurrentPage: 1,
      /* 节点审批人下标 */
      nodeApproverIndex: '',
      departmentPeopleList: [],
      departmentActiveIndex: null,
      dialogRoleType3Visible: false,
      subLimit: '',
      activeSelectNodeApproval: null
    }
  },

  created() {
    this.initDetails()
    this.initRoleTypeDepartment()
  },

  methods: {
    /* 某角色的管理范围内的组织信息 */
    initRoleTypeDepartment() {
      let keyword = "property";
      Staff.getModuleManagerDepartmentList(keyword).then((res) => {
        if (res.success) {
          let arr = this.mapChildDisable(res.result)
          this.staffAndDepartmentList = mapId2(arr)
        } else {
          this.$message.error(res.message);
        }
      })
    },

    mapChildDisable(child, id) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        if (value.zzdCode) {
          obj.id = `${value.zzdCode}|${value.deptId}`
        } else {
          obj.id = value.id;
        }
        obj.id2 = value.id
        obj.teamId = id
        obj.zzdCode = value.zzdCode
        obj.departmentName = value.name;
        obj.image = value.image;
        obj.level = value.level;
        obj.parentId = value.parentId;
        obj.parentName = value.parentName;
        obj.departmentNum = value.totalNum;
        obj.departmentHead = value.head;
        obj.jurisdictionHead = value.leader;
        obj.disabled = true
        if (value.level == 4) obj.disabled = false
        if (value.subList && value.subList.length > 0) {
          obj.subList = this.mapChildDisable(value.subList, value.parentId);
        } else {
          obj.subList = [];
        }
        arr.push(obj);
      });
      return arr;
    },
    
    initStaffList() {
      let searchDepartment = this.staff
      let id = this.assignDepartmentId != 0? this.assignDepartmentId: getTeamId()
      let currentPage = this.stayDistributionCurrentPage
      Staff.getPeopleList(id, searchDepartment, currentPage).then(res => {
        if (res.success) {
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.phone = i.phoneNo;
            obj.image = i.image;
            obj.keyword = `${this.assignDepartmentId}/${i.id}`
            arr.push(obj);
          });
          this.assignPeople = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initDetails() {
      let type = this.isApprovelType
      Assets.postProcedure(type).then(res => {
        if (res.success) {
          let arr = []
          res.result.map((i, index) => {
            let obj = {}
            obj.id = i.id
            obj.deptId = i.deptId
            obj.subLimit = handleAmount(i.subLimit,2)
            obj.agentId = []
            obj.agent = []
            obj.thirdDeptList = []
            obj.name = `流程${index+1}`
            i.approveSettingDepartmentRelateVoList.map(v => {
              let obj2 = {}
              let obj3 = {}
              obj3.id = v.deptId
              obj3.departmentName = v.deptName
              obj3.id2 = v.deptId
              obj2.deptId = v.deptId
              obj.agentId.push(obj2)
              obj.agent.push(v.deptName)
              obj.thirdDeptList.push(obj3)
            })
            obj.agentDepartmentList = []
            i.approveTitleResVoList.map(j => {
              j.approveSettingDetailVoList.map((v, index) => {
                let obj2 = {}
                obj2.id = v.id
                if (index == 0) {
                  obj2.approvelTitle = j.approveTitle
                } else {
                  obj2.approvelTitle = ''
                }
                obj2.isNeedInput = false
                if (v.roleType == 2 || v.roleType == 5 || v.roleType == 6) obj2.isNeedInput = true
                obj2.approveSettingId = v.approveSettingId
                obj2.roleId = v.roleId
                obj2.roleType = v.roleType
                obj2.roleName = v.roleName
                obj2.isContinue = v.isContinue
                obj2.isBranch = v.nextSplit
                obj2.userId = v.userId
                obj2.userName = v.userName
                obj2.price = handleAmount(v.baseAmount,2)
                obj2.isDisabled = v.addButton == 0 ? true: false
                obj2.splitUserList = v.splitUserList
                obj2.nodeApproverList = []
                if (v.splitUserList) {
                  let nodeApproverName = []
                  let nodeApproverList = []
                  v.splitUserList.map(val => {
                    let obj3 = {}
                    obj3.id = val.userId
                    obj3.name = val.userName
                    nodeApproverName.push(val.userName)
                    nodeApproverList.push(obj3)
                  })
                  obj2.nodeApproverName= nodeApproverName.join('；')
                  obj2.nodeApproverList= nodeApproverList
                }
                obj.agentDepartmentList.push(obj2)
              })
            })
            arr.push(obj)
          })
          this.procedureList = arr
          if (arr.length > 0) {
            this.detailsList = arr[0].agentDepartmentList
            this.agent = arr[0].agent.join('；')
            this.agentId = arr[0].agentId
            this.thirdDeptList = arr[0].thirdDeptList
            this.subLimit = arr[0].subLimit
            this.initRoleType()
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },

    selectType(index, item) {
      this.activeIndex = index
      this.detailsList = item.agentDepartmentList
      this.agentId = item.agentId
      this.agent = item.agent.join('；')
      this.thirdDeptList = item.thirdDeptList
      this.subLimit = item.subLimit
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command,index){
      return {
        'value': value,
        'command':command,
        'index': index
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "delete":
          this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            confirmButtonClass: 'btn-red',
            cancelButtonClass: 'btn-gray'
          }).then(() => {
            if (command.value.id) {
              this.delProcedureList(command.value.id)
            } else {
              this.procedureList.splice(command.index,1)
            }
          });
          break;
      }
    },

    /* 删除流程 */
    delProcedureList(id) {
      let data = {
        id
      }
      Assets.postDelProcedure(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '流程删除成功'
          });
          this.activeIndex = 0
          this.initDetails()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 新增流程 */
    addProcedure() {
      let length = this.procedureList.length
      let agentDepartmentList = []
      if (this.isApprovelType == 4) {
        agentDepartmentList = [
          {
            roleType: 1,
            roleName: "经办人部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 10,
            roleName: "资产管理员",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '管理部门',
            isNeedContinue: false,
            isNeedInput: false,
            price: ''
          }
        ]
      } else if (this.isApprovelType == 3) {
        agentDepartmentList = [
          {
            roleType: 10,
            roleName: "资产管理员",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '管理部门',
            isNeedContinue: false,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 12,
            roleName: "资产管理部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          }
        ]
      } else if (this.isApprovelType == 5 || this.isApprovelType == 9) {
        agentDepartmentList = [
          {
            roleType: 1,
            roleName: "经办人部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 2,
            roleName: "业务分管领导",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: true,
            price: ''
          },
          {
            roleType: 10,
            roleName: "资产管理员",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '管理部门',
            isNeedContinue: false,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 12,
            roleName: "资产管理部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '资产部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 3,
            roleName: "财务审核人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '财务审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: '',
            userId: 0,
            userName: ''
          },
          {
            roleType: 4,
            roleName: "财务负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 5,
            roleName: "财务分管领导",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: true,
            price: ''
          },
          {
            roleType: 6,
            roleName: "主官领导",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '领导审批',
            isNeedContinue: true,
            isNeedInput: true,
            price: ''
          },
        ]
      } else if (this.isApprovelType == 8) {
        agentDepartmentList = [
          {
            roleType: 1,
            roleName: "经办人部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 2,
            roleName: "业务分管领导",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: true,
            price: ''
          },
          {
            roleType: 10,
            roleName: "资产管理员",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '管理部门',
            isNeedContinue: false,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 12,
            roleName: "资产管理部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '资产部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 3,
            roleName: "财务审核人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '财务审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: '',
            userId: 0,
            userName: ''
          },
          {
            roleType: 4,
            roleName: "财务负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 5,
            roleName: "财务分管领导",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: true,
            price: ''
          },
          {
            roleType: 6,
            roleName: "主官领导",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '领导审批',
            isNeedContinue: true,
            isNeedInput: true,
            price: ''
          },
        ]
      } else if (this.isApprovelType == 7) {
        agentDepartmentList = [
          {
            roleType: 1,
            roleName: "经办人部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 10,
            roleName: "资产管理员",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '管理部门',
            isNeedContinue: false,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 12,
            roleName: "资产管理部门负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '资产部门审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
          {
            roleType: 3,
            roleName: "财务审核人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '财务审批',
            isNeedContinue: true,
            isNeedInput: false,
            price: '',
            userId: 0,
            userName: ''
          },
          {
            roleType: 4,
            roleName: "财务负责人",
            isContinue: 0,
            isBranch: 0,
            isDisabled: false,
            approvelTitle: '',
            isNeedContinue: true,
            isNeedInput: false,
            price: ''
          },
        ]
      }
      let obj = {
        nodeApproverList: [],
        nodeApproverName: [],
        thirdDeptList: [],
        agentId: [],
        agent: [],
        name: `流程${length+1}`,
        agentDepartmentList: agentDepartmentList,
      }
      this.procedureList.push(obj)
      this.subLimit = ''
      this.agent = ''
      this.thirdDeptList = []
      this.activeIndex = this.procedureList.length-1
      this.detailsList = this.procedureList[this.activeIndex].agentDepartmentList
    },

    /* 跳过 */
    skip(index) {
      this.detailsList[index].isContinue = 1
      this.detailsList[index].isDisabled = true
    },

    /* 恢复 */
    recovery(index) {
      this.detailsList[index].isContinue = 0
      this.detailsList[index].isDisabled = false
    },

    /* 添加审批分支 */
    addBranch(index) {
      this.detailsList.map((i,v) => {
        i.isDisabled = true
        if (index == v) {
          i.isBranch = 1
        } else {
          i.isBranch = 0
        }
      })
    },

    /* 删除分支 */
    delBranch(index) {
      this.detailsList[index].nodeApproverName = ''
      this.detailsList[index].nodeApproverList = []
      this.detailsList[index].isBranch = 0
      this.detailsList.map(i => {
        if (!i.isContinue) {
          i.isDisabled = false
        }
      })
    },

    save() {
      if (this.agentId.length == 0) {
        this.$message.error('请先选择经办人')
        return
      }
      if (!this.procedureList[this.activeIndex].id) this.addProcedureList()
      if (this.procedureList[this.activeIndex].id) this.modProcedureList()
    },

    /* 新增流程 */
    addProcedureList() {
      let deptIdList = []
      let sort = 0
      let approveSettingDetailList = []
      this.agentId.map(i => {
        deptIdList.push(i.deptId)
      })
      let subLimit = handleAmount(Number(this.subLimit),1)
      let isFlag = false
      this.detailsList.map((i, index) => {
        let obj = {}
        obj.isContinue = i.isContinue
        obj.nextSplit = i.isBranch
        obj.roleType = i.roleType
        obj.baseAmount = handleAmount(Number(i.price),1)
        let num = 1
        num += sort
        sort = num
        obj.sort = num
        obj.userId = i.userId ? i.userId:0
        if (i.roleType == 12 && i.userId == undefined &&i.isContinue == 0) isFlag = true
        if (i.isBranch) {
          i.nodeApproverList.map(i => {
            let obj2 = {}
            obj2.isContinue = 0
            obj2.nextSplit = 0
            obj2.roleType = 0
            obj2.sort = index+2
            obj2.userId = i.id
            approveSettingDetailList.push(obj2)
          }) 
          sort = sort+1
        }
        approveSettingDetailList.push(obj)
      })
      if (isFlag) return this.$message.error('请设置资产管理部门负责人')
      let data = {
        type: this.isApprovelType,
        deptIdList,
        subLimit,
        approveSettingDetailList
      }
      Assets.postAddProcedure(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '流程新增成功'
          });
          this.activeIndex = 0
          this.initDetails()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 修改流程 */
    modProcedureList() {
      let deptIdList = []
      let detailList = []
      let sort = 0
      let id = this.procedureList[this.activeIndex].id
      this.agentId.map(i => {
        deptIdList.push(i.deptId)
      })
      let subLimit = handleAmount(Number(this.subLimit),1)
      let isFlag = false
      this.detailsList.map((i, index) => {
        let obj = {}
        obj.isContinue = i.isContinue
        obj.nextSplit = i.isBranch
        obj.roleType = i.roleType
        obj.baseAmount = handleAmount(Number(i.price),1)
        let num = 1
        num += sort
        sort = num
        obj.sort = num
        obj.userId = i.userId
        if (i.roleType == 12 && i.userId == '' && i.isContinue == 0) isFlag = true
        if (i.isBranch) {
          i.nodeApproverList.map(i => {
            let obj2 = {}
            obj2.isContinue = 0
            obj2.nextSplit = 0
            obj2.roleType = 0
            obj2.sort = index+2
            obj2.userId = i.id
            detailList.push(obj2)
          })
          sort = sort+1
        }
        detailList.push(obj)
      })
      if (isFlag) return this.$message.error('请设置资产管理部门负责人')
      let data = {
        id,
        type: this.isApprovelType,
        subLimit,
        deptIdList,
        detailList
      }
      Assets.postModProcedure(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '流程修改成功'
          });
          this.activeIndex = 0
          this.initDetails()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    
    /* -------------------  以下是选择部门方法  --------------------- */
    setUp() {
      this.departmentDialog = true;
      this.$bus.emit('initSelectDepartment', this.thirdDeptList)
    },

    /* 关闭部门弹窗 */
    oPenOrCloseDepartmentDialog(data) {
      this.departmentDialog = data;
    },

    /* 确定部门弹窗 */
    submitSelectData(data) {
      let arr = []
      let arr2 = []
      data.map(i => {
        let obj = {}
        obj.deptId = i.id2
        arr.push(obj)
        arr2.push(i.departmentName)
      })
      this.agent = arr2.join('；')
      this.agentId = arr
      this.oPenOrCloseDepartmentDialog(false);
      this.initRoleType()
    },

    /* ------------------  以下是选择节点审批人方法  -------------------- */
    setNodeApprovelPeople(index) {
      this.nodeApproverIndex = index
      this.dialogVisible = true;
    },

    nodeApprovelPeopleClose() {
      this.staff = "",
      this.activeSelectNodeApproval = null
      this.selectAssignPeople = []
      this.assignPeople = []
      this.assignDepartmentId = 0
      this.dialogVisible = false;
    },

    /* 多选 */
    handleSelectionSKitchenChange(val) {
      let selectAssignPeople = this.unique(this.selectAssignPeople.concat(val))
      if (selectAssignPeople.length > 3) {
        this.$refs.multipleTable.clearSelection()
        this.selectAssignPeople.map(i => {
          this.$refs.multipleTable.toggleRowSelection(i)
        })
        this.$message.error('最多只能选择3个审批人')
        return
      }
      this.selectAssignPeople = selectAssignPeople
    },
    
    unique(arr) {
      let res = []
      let map = new Map()
      for (let i of arr) {
        if (!map.has(i.keyword)) {
          map.set(i.keyword, i)
        }
      }
      res = [...map.values()]
      return res
    },

    nodeApprovelPeopleConfirm() {
      let nodeApproverName = []
      let arr = []
      this.selectAssignPeople.map(i => {
        nodeApproverName.push(i.name)
        arr.push(i)
      })
      this.detailsList[this.nodeApproverIndex].nodeApproverName = nodeApproverName.join('；')
      this.detailsList[this.nodeApproverIndex].nodeApproverList = arr
      this.nodeApprovelPeopleClose()
    },

    removeSelectNodeApproval(index) {
      this.selectAssignPeople.splice(index,1)
    },

    highSelectNodeApproval(index) {
      this.activeSelectNodeApproval = index
    },
    
    selectAssignDepartment(v) {
      this.assignDepartmentId = v.id
      this.initStaffList()
    },

    searchAssignPeople() {
      this.initStaffList()
    },

    /* 设置部门负责人 */
    setDepartmentPeople(index) {
      this.departmentPeopleIndex = index
      this.dialogRoleType3Visible = true
    },

    selectDepartmentPeople(row, index) {
      this.departmentActiveIndex = index
      this.procedureList[this.activeIndex].agentDepartmentList[this.departmentPeopleIndex].userName = row.name
      this.procedureList[this.activeIndex].agentDepartmentList[this.departmentPeopleIndex].userId = row.userId
    },

    handleClose() {
      this.dialogRoleType3Visible = false
    },

    initDepartmentHead() {
      this.initAllRoleStaff(1)
    },

    initFinancialAudit() {
      this.initAllRoleStaff(3)
    },

    initRoleType() {
      this.initDepartmentHead()
      this.initFinancialAudit()
    },
    
    /* 根据id获取所有的角色成员 */
    initAllRoleStaff(roleType) {
      let deptId = this.agentId.length > 0?this.agentId[0].deptId: ''
      let searchFlag = 1
      Approval.postIdAllRoleStaff(roleType, deptId, searchFlag).then(res => {
        if (res.success) {
          let departmentPeopleList = []
          let financialAuditList = []
          res.result.map(i => {
            if (roleType == 1) {
              let departmentPeopleObj = {}
              departmentPeopleObj.userId = i.userId
              let deptName = i.deptName ? `(${i.deptName})` : ''
              departmentPeopleObj.name = `${i.userName}${deptName}`
              departmentPeopleList.push(departmentPeopleObj)
            }
            if (roleType == 3) {
              let obj = {}
              obj.userId = i.userId
              obj.name = i.userName
              financialAuditList.push(obj)
            }
          })
          if (roleType == 1) this.departmentPeopleList = departmentPeopleList
          if (roleType == 3) {
            this.financialAuditList = financialAuditList
            this.detailsList.map(i => {
              if (i.roleType == 3 && i.userId == 0) {
                i.userId = financialAuditList.length > 0 ?financialAuditList[0].userId :0
                i.userName = financialAuditList.length > 0 ?financialAuditList[0].name :''
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
  }
}
</script>

<style lang='scss'>
.assets-approvel {
  flex: 1;
  background-color: $bg-white;
  .assets-approvel-container {
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .left-container {
    width: 288px;
    padding: 16px;
    @include flex-column-center;
    justify-content: space-between;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
    .add-type-content {
      width: 256px;
      position: relative;
      overflow-y: auto;
      .type {
        height: 40px;
        @include flex-between;
        padding: 0px 12px;
        cursor: pointer;
        .type-title {
          @include flex-start;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
          img {
            width: 20px;
            height: 20px;
            margin-right: 16px;
          }
        }
      }
      .active {
        background: $bg-Tab;
        .type-title {
          color: $color-DeepReddishBlue;
        }
      }
      .nothing-add {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        img {
          width: 104px;
          height: 87px;
        }
        p {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-LightGrey;
          margin-top: 20px;
        }
      }
    }
  }
  .right-container {
    flex: 1;
    padding: 28px 19px;
    margin-bottom: 80px;
    position: relative;
    .sub-title {
      color: $color-Step;
      font-size: $fs-medium-s;
      border-left: 4px solid $bg-DeepReddishBlue;
      text-align: left;
      padding-left: 5px;
      margin-bottom: 22px;
    }
    .condition {
      color: $color-Step;
      font-size: $fs-small-l;
      text-align: left;
      padding-left: 24px;
      margin-bottom: 20px;
    }
    .condition-row {
      @include flex-start;
      padding-left: 56px;
      span {
        width: 80px;
        font-size: $fs-small-l;
        color: $color-FinancialAudit;
      }
    }
    .row {
      padding-left: 38px;
      margin-bottom: 25px;
      .step {
        @include flex-start;
      }
      .step-num {
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-right: 22px;
        color: $color-white;
        background: url("../assets/step.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .step-node {
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-right: 22px;
      }
      .step-active {
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-right: 22px;
        color: $color-BlackGrey;
        background: url("../assets/gray.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .stepActive {
        color: $color-LightGrey;
      }
      .step-main {
        flex: 1;
        min-height: 56px;
        @include flex-between;
        background: $bg-StepMain;
        padding: 0px 20px;
        font-size: $fs-medium-s;
        font-weight: 400;
        color: $color-Step;
        .step-main-right-container {
          @include flex-start;
          .set {
            margin-right: 10px;
          }
        }
        .step-main-right {
          color: $color-MainRight;
          cursor: pointer;
          width: 40px;
        }
        .operation-btn {
          display: flex;
          .step-main-right {
            margin-left: 20px;
          }
          .del {
            color: $color-Crimson;
          }
        }
      }
      .step-main-agent {
        text-align: left;
        padding: 10px 20px;
        line-height: 20px;
        box-sizing: border-box;
        &-left {
          flex: 1;
          @include flex-start;
          &-title {
            display: inline-block;
            width: 70px;
            text-align: left;
          }
          &-content {
            flex: 1;
          }
        }
      }
      .financial-audit {
        height: 55px;
        line-height: 55px;
        margin-left: 62px;
        background: $bg-white;
        padding: 0px 20px;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-FinancialAudit;
        border: 1px solid $bg-ShallowLightSnow;
        border-top: none;
        @include flex-start;
        .financial-title {
          margin-right: 30px;
        }
        .el-radio__label {
          color: $color-FinancialAudit;
        }
      }
    }
    .add-branch {
      @include flex-start;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-Step;
      line-height: 24px;
      margin-bottom: 25px;
      .approvel-node-title {
        font-size: $fs-medium-s;
      }
      .btn-border-text-blue,
      .btn-gray {
        margin-left: 35px;
        margin-right: 20px;
      }
    }
    .foot-container {
      width: calc(100% - 545px);
      box-sizing: border-box;
      height: 64px;
      @include flex-start;
      position: fixed;
      right: 37px;
      bottom: 0;
      padding-left: 30px;
      background: $bg-white;
      box-shadow: 0px -4px 8px 0px rgba(31, 31, 31, 0.06);
    }
    .nothing {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
  }
  .add-type {
    width: 200px;
  }
  .el-dropdown-link {
    @include extend-click;
  }
  
  .dialog-content {
    margin: 20px;
    background: $bg-ChangeDepartmentTree;
    .department-people {
      height: 40px;
      line-height: 40px;
      padding-left: 21px;
      text-align: left;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $bg-grey;
      &:hover {
        color: $color-DepartmentPeople;
        background: $bg-ChangeDepartmentHighTree;
      }
    }
    .departmentActive {
      color: $color-DepartmentPeople;
      background: $bg-ChangeDepartmentHighTree;
    }
  }
  .assign-name {
    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }
  .stayDistribution {
    display: flex;
    .table-left {
      width: 370px;
      height: 360px;
      padding: 20px;
      border-right: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: auto;
      @include scrollbarNotrack();
      .table-left-title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        text-align: left;
        padding-left: 28px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
    }
    .table-right {
      flex: 1;
      padding: 20px;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 20px;
      }
    }
  }
  .dialog-footer-node {
    width: 100%;
    @include flex-between;
    .node-select-approval {
      @include flex-start;
      .node-item-approval {
        width: 112px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid $bg-DoopLightSnow;
        border-radius: 2px;
        margin-right: 20px;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-grey;
        position: relative;
        cursor: pointer;
        .el-icon-circle-close {
          position: absolute;
          right: -8px;
          top: -8px;
          color: $color-DeepReddishBlue;
          background: $bg-white;
        }
      }
      .active-node-item-approval {
        color: $color-DeepReddishBlue;
        border: 1px solid $color-DeepReddishBlue;
      }
    }
  }
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
</style>
